import { ChevronRight, type LucideIcon } from 'lucide-react';

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from 'ressources/src/components/ui/collapsible';

import {
  SidebarGroup,
  // SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem
} from 'ressources/src/components/ui/sidebar';
import { LinkProtected } from '@r/components/link-protected/link-protected.tsx';
import type { LinkProps } from '@tanstack/react-router';

interface MenuItemBase {
  title: string;
  icon?: LucideIcon;
  isActive?: boolean;
  isVisible?: boolean;
}

interface LeafMenuItem extends MenuItemBase {
  url: LinkProps['to'];
  items?: never;
}

interface ParentMenuItem extends MenuItemBase {
  url: LinkProps['to'] | '#';
  items: LeafMenuItem[];
}

type MenuItem = ParentMenuItem | LeafMenuItem;

export function NavMain({ items }: { items: MenuItem[] }) {
  const hasSubItems = (item: MenuItem) => item.items && item.items.length > 0;

  return (
    <SidebarGroup>
      {/*<SidebarGroupLabel>Platform</SidebarGroupLabel>*/}
      <SidebarMenu>
        {items
          .filter((item) => item.isVisible)
          .map((item) => (
            <Collapsible
              key={item.title}
              asChild
              defaultOpen={item.isActive}
              className="group/collapsible"
            >
              <SidebarMenuItem isActive={hasSubItems(item) && item.isActive}>
                <CollapsibleTrigger asChild>
                  <SidebarMenuButton
                    tooltip={item.title}
                    asChild={!hasSubItems(item)}
                    isActive={!hasSubItems(item) && item.isActive}
                  >
                    {hasSubItems(item) || item.url === '#' ? (
                      <>
                        {item.icon && <item.icon />}
                        <span>{item.title}</span>
                        <ChevronRight className="ml-auto transition-transform duration-200 group-data-[state=open]/collapsible:rotate-90" />
                      </>
                    ) : (
                      <LinkProtected to={item.url}>
                        {item.icon && <item.icon />}
                        <span>{item.title}</span>
                      </LinkProtected>
                    )}
                  </SidebarMenuButton>
                </CollapsibleTrigger>
                {hasSubItems(item) && (
                  <CollapsibleContent>
                    <SidebarMenuSub>
                      {item.items?.map((subItem) => (
                        <SidebarMenuSubItem key={subItem.title}>
                          <SidebarMenuSubButton asChild isActive={subItem.isActive}>
                            <LinkProtected to={subItem.url}>
                              <span>{subItem.title}</span>
                            </LinkProtected>
                          </SidebarMenuSubButton>
                        </SidebarMenuSubItem>
                      ))}
                    </SidebarMenuSub>
                  </CollapsibleContent>
                )}
              </SidebarMenuItem>
            </Collapsible>
          ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
